import DashboardLayout from "../../../Layout/DashboardLayout";
import { message, Modal } from "antd";
import "react-international-phone/style.css";
import { useBranchesHelper } from "./useBranchesHelper";
import BranchesTable from "./components/BranchesTable";
import AddNewBranch from "./components/AddNewBranch";
import Input from "../../../Components/Input";
import { PhoneInput } from "react-international-phone";
import Select from "../../../Components/Select";
import Button from "../../../Components/Button";
import Textarea from "../../../Components/Textarea";
import { queryClient } from "../../../services/queryClient";

const BranchManagement = () => {
  const {
    isModalOpen,
    payload,
    states,
    lgas,
    selectedState,
    selectedLGA,
    isCreatingBranch,
    mutateAsync,
    setPayload,
    handleInputChange,
    handleStateChange,
    handleLGAChange,
    handleModalClose,
    showModal,
  } = useBranchesHelper();

  return (
    <DashboardLayout
      title="Branch Management"
      back={false}
      right={
        <button
          onClick={showModal}
          className="text-white bg-orange p-3 height-auto rounded-[10px] text-[14px] flex gap-[10px] items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
          <span>Add New Branch</span>
        </button>
      }
    >
      <Modal
        title="Create New Branch"
        open={isModalOpen}
        onCancel={handleModalClose}
        footer={null}
      >
        <div>
          <Input
            type={"text"}
            name={"name"}
            label={"name"}
            value={payload.name}
            placeholder={"Enter branch name"}
            onChange={handleInputChange}
          />
          <label htmlFor="phoneNumber" className="mt-[20px]">
            Enter Phone Number
          </label>
          <PhoneInput
            defaultCountry="ng"
            className="mt-[13px] mb-3"
            name="phoneNumber"
            value={payload.phoneNumber}
            onChange={(phone) => setPayload({ ...payload, phoneNumber: phone })}
          />
          <Select
            label={"State"}
            name={"state"}
            value={selectedState}
            options={states}
            onChange={handleStateChange}
          />

          <Select
            label={"Local Government Area"}
            name={"lga"}
            value={selectedLGA}
            options={lgas}
            onChange={handleLGAChange}
          />
          <Textarea
            label="Address"
            name={"address"}
            value={payload?.address}
            placeholder={"Enter Branch Address"}
            onChange={handleInputChange}
          />
          <Button
            className={`text-white p-[12px] w-full font-bold rounded-md ease-in-out duration-300 bg-brown`}
            disabled={
              !payload.name ||
              !payload.phoneNumber ||
              !payload.address ||
              !selectedState ||
              !selectedLGA
            }
            isLoading={isCreatingBranch}
            onClick={() => {
              mutateAsync(payload, {
                onSuccess: async (data: any) => {
                  message.success(data?.message);
                  handleModalClose();
                  queryClient.invalidateQueries({ queryKey: [""] });
                  handleModalClose();
                },
                onError: (error: any) => {
                  message.error(error?.response?.data?.message);
                  handleModalClose();
                },
              });
            }}
            label={"Proceed"}
          />
        </div>
      </Modal>
      <BranchesTable />
    </DashboardLayout>
  );
};

export default BranchManagement;
